import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import localStorage from "redux-persist/lib/storage";
import { composeWithDevTools } from "redux-devtools-extension";
import RootReducer from "../reducers/RootReducer";
import RootMiddleware from "../middlewares/RootMiddleware";

const persistConfig = {
  key: 'root',
  storage: localStorage,
  blacklist: ['auth'],
  whitelist: ['settings', 'filters'],
};

const persistedReducer = persistReducer(persistConfig, RootReducer)

export default () => {
  let store = createStore(
    persistedReducer,
    {},
    composeWithDevTools(RootMiddleware)
  );
  let persistor = persistStore(store)
  return { store, persistor }
}
